var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 40,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "send_svg__a",
  width: 41,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M.666 0h40v40h-40z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#send_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M5.666 33.334v-10L18.999 20 5.666 16.667v-10L37.333 20 5.666 33.334Z"
}))));
export default SvgSend;